module.exports = __webpack_public_path__ + "images/psp/car.webp";